import PropTypes from 'prop-types';
import React, { Component } from 'react';
import RouterProvider from './router/router-provider';
import enUS from 'antd/lib/locale-provider/en_US';
import { ConfigProvider } from 'antd';
import { Provider } from 'mobx-react';

export default class PublicProvider extends Component {
  // eslint-disable-line
  static propTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <Provider
        store={this.props.store}
        router={this.props.store.router}
        ui={this.props.store.ui}
        uploads={this.props.store.uploads}
        sharedPackets={this.props.store.sharedPackets}
        features={this.props.store.features}
        signaturePackets={this.props.store.signaturePackets}
        account={this.props.store.account}
        requestPacketAccess={this.props.store.requestPacketAccess}
        annotations={this.props.store.annotations}
        transactions={null}
        transactionDocuments={null}
        activities={null}
      >
        <RouterProvider router={this.props.router}>
          <ConfigProvider locale={enUS}>{this.props.children}</ConfigProvider>
        </RouterProvider>
      </Provider>
    );
  }
}
